/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementChangeManagementConfigurationMapping extends models.JiraServiceManagementConfigurationMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementChangeManagementConfigurationMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementChangeManagementConfigurationMapping>): JiraServiceManagementChangeManagementConfigurationMapping {
        let obj = Object.assign(new JiraServiceManagementChangeManagementConfigurationMapping(), model);
        JiraServiceManagementChangeManagementConfigurationMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementChangeManagementConfigurationMapping>): JiraServiceManagementChangeManagementConfigurationMapping {
        if (!model) return null;
        return JiraServiceManagementChangeManagementConfigurationMapping.newInstance(<JiraServiceManagementChangeManagementConfigurationMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementChangeManagementConfigurationMapping) {
        if (!obj) return;

        models.JiraServiceManagementChangeManagementConfigurationMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementChangeManagementConfigurationMapping): boolean {
        if (models.JiraServiceManagementConfigurationMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementChangeManagementConfigurationMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
